import "../../assets/scss/global.scss";
import { commaFormaterFixed } from "../../core/global/global-country-functions";

export default function TableComponent({ label, tableData, colOne, colTwo }) {
  return tableData && Array.isArray(tableData) && tableData.length && colOne && colTwo ? (
    <>
      {" "}
      <div className="d-flex card-border py-2">
        <div className="col-6">{label ? label : ""}</div>
      </div>
      {tableData.map((item) => {
        return (
          <div className="d-flex pl-4 py-2 card-border">
            <div className="col-6">{item[colOne]}</div>
            <div className="col-6 bold-data">{commaFormaterFixed(item[colTwo])}</div>
          </div>
        );
      })}
    </>
  ) : (
    "NA"
  );
}
